import { Sparkles } from 'lucide-react';
import { useSubscribe } from '@/hooks/usePayment';
import { useNavigate } from 'react-router-dom';

interface SubscribeButtonProps {
	plan: Payments.Plan;
	className?: string;
}

export const SubscribeButton = ({
	plan,
	className = '',
}: SubscribeButtonProps) => {
	const navigate = useNavigate();
	const { mutate, isPending } = useSubscribe((data) => {
		if (data.url) {
			window.location.href = data.url;
		} else if (data.success) {
			navigate('/home');
		}
	});

	// Substitua o return do SubscribeButton.tsx por este:
	return (
		<button
			onClick={(e) => {
				e.preventDefault();
				mutate({ plan });
			}}
			disabled={isPending}
			// Removi o border-2 daqui para ele não estragar a sua classe de fora
			className={`flex w-full items-center justify-center gap-2 rounded-lg border-solid py-2 transition-all active:scale-95 disabled:opacity-50 ${className}`}
		>
			<Sparkles className={`size-4 ${isPending ? 'animate-spin' : ''}`} />
			<span className="text-sm font-semibold">
				{isPending ? 'Processando...' : 'Começar agora'}
			</span>
		</button>
	);
};
